export default __webpack_public_path__ + "static/media/mobileWef5Full.716cb777.png";